import {
    DEBUG,
    VERBOSE,
    INFO,
    WARN,
    ERROR,
    CRITICAL
} from '../logLevels';

const colorMap = {
    [DEBUG]: 'magenta',
    [VERBOSE]: 'cyan',
    [INFO]: 'cyan',
    [WARN]: 'yellow',
    [ERROR]: 'red',
    [CRITICAL]: 'red'
};

export default colorMap;
